<h2>Somtoday Connect geeft grip op digitaal leren</h2>
<span style="text-align: center;"><img src="assets/img/infographic.png" style="width:100%; max-width:1000px;" /></span>
<div class="info-blocks">
  <app-big-info-detail *ngFor="let block of homeData" [information]="block"></app-big-info-detail>
</div>
<app-bottombar></app-bottombar>
